import React from 'react'

import './_success-message.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import checkedIcon from '../../assets/icons/checked.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    size?: 'default' | 'l'
    success?: boolean
  }
>

const SuccessMessage = ({
  className,
  children,
  size = 'default',
  success = false,
  ...props
}: Props) => (
  <div {...props} className={cn('SuccessMessage', {[`size-${size}`]: !!size, success}, className)}>
    <Icon source={checkedIcon} />
    <br />
    {children}
  </div>
)

export default SuccessMessage
